import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

export const styles = {};

export const overrides = {
	'.SimpleviewListingList-root': {
		'.listingsCategory__description': {
			color: getColor('ivory', 700),
			paddingBottom: remCalc(120),
			paddingTop: remCalc(80),
		},
		'.SimpleviewListingList-results': {
			paddingBottom: remCalc(80),
			paddingTop: remCalc(80),
		}
	}
};

export default styles;